module.exports = __webpack_public_path__ + "img/logo.e4c690fa.png";